module.exports = "<div class=\"form-group\">\r\n    <label for=\"cmb\">Marca</label>\r\n    <ss-multiselect-dropdown [options]=\"options\" id=\"cmb\" [(ngModel)]=\"optionsModel\" (ngModelChange)=\"onChange()\"></ss-multiselect-dropdown>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/designers/layout/deprecated/marca.designer.component.html
// module id = ../../../../../src/app/private/sxfdesigner/components/designers/layout/deprecated/marca.designer.component.html
// module chunks = main